import React from "react";

export default function BlogPostBody({ post }) {
  return (
    <div className="flex flex-col">
      <div className="mb-4">
        <span className="inline-block text-[11px] font-semibold text-[#7209B7] bg-purple-50 px-2.5 py-1 rounded-full mb-3">
          {post.tag}
        </span>
        <h1 className="text-xl sm:text-4xl md:text-3xl font-bold text-black leading-tight max-w-3xl tracking-tight">
          {post.title}
        </h1>
      </div>

      <div className="space-y-4 text-slate-700 text-[16px] leading-relaxed">
        {post.content.map((block, i) => {
          if (block.type === "h2") {
            return (
              <h2
                key={i}
                className="text-2xl font-semibold text-black !mt-10 !mb-1"
              >
                {block.text}
              </h2>
            );
          }
          return <p key={i}>{block.text}</p>;
        })}
      </div>

      {/* Author bio */}
      <div className="mt-12 bg-[#F3EEFA] rounded-[17px] p-6 lg:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex flex-row items-start gap-4 lg:gap-6 text-left">
          <img
            src={post.avatar}
            alt={post.author}
            className="w-14 h-14 sm:w-24 sm:h-24 rounded-full object-cover shrink-0"
          />
          <div className="flex flex-col justify-center h-full pt-1 sm:pt-2">
            <h3 className="text-[15px] font-bold text-black">
              {post.author}
            </h3>
            <p className="text-[13px] text-slate-600 mb-2">
              {post.authorRole}
            </p>
            <p className="text-[12px] text-slate-700 leading-relaxed ">
              {post.authorBio}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
